import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store.js";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles/tailwind.generated.css";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import * as serviceWorker from "./serviceWorker";
// import ReactPWAInstallProvider from "react-pwa-install";
let persistor = persistStore(store);

ReactDOM.render(
  // <ReactPWAInstallProvider enableLogging>
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  // </ReactPWAInstallProvider>
  document.getElementById("root")
);
serviceWorker.unregister();
